const PROVINCIAS = {
  "SAN JOSE": ["CENTRAL", "ESCAZU", "DESAMPARADOS", "PURISCAL", "TARRAZU", "ASERRI", "MORA",
    "GOICOECHEA", "SANTA ANA", "ALAJUELITA", "VAZQUEZ DE CORONADO", "ACOSTA", "TIBAS", "MORAVIA",
    "MONTES DE OCA", "TURRUBARES", "DOTA", "CURRIDABAT", "PEREZ ZELEDON", "LEON CORTES CASTRO"],
  "ALAJUELA": ["CENTRAL", "SAN RAMON", "GRECIA", "SAN MATEO", "ATENAS", "NARANJO", "PALMARES",
    "POAS", "OROTINA", "SAN CARLOS", "ZARCERO", "SARCHI", "UPALA", "LOS CHILES", "GUATUSO", "RIO CUARTO"],
  "CARTAGO": ["CENTRAL", "PARAISO", "LA UNION", "JIMENEZ", "TURRIALBA", "ALVARADO", "OREAMUNO", "EL GUARCO"],
  "HEREDIA": ["CENTRAL", "BARVA", "SANTO DOMINGO", "SANTA BARBARA", "SAN RAFAEL", "SAN ISIDRO",
    "BELEN", "FLORES", "SAN PABLO", "SARAPIQUI"],
  "GUANACASTE": ["LIBERIA", "NICOYA", "SANTA CRUZ", "BAGACES", "CARRILLO", "CAÑAS", "ABANGARES",
    "TILARAN", "NANDAYURE", "LA CRUZ", "HOJANCHA"],
  "PUNTARENAS": ["CENTRAL", "ESPARZA", "BUENOS AIRES", "MONTES DE ORO", "OSA", "QUEPOS",
    "GOLFITO", "COTO BRUS", "PARRITA", "CORREDORES", "GARABITO"],
  "LIMON": ["CENTRAL", "POCOCI", "SIQUIRRES", "TALAMANCA", "MATINA", "GUACIMO"],
};

export const CANTONES = Object.entries(PROVINCIAS).flatMap(([p, cs]) => cs.map((c) => `${p}-${c}`));
